import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setTourFilter as setTourFilterAction,
  setTourSearch as setTourSearchAction,
} from '@src/store/ui/actions';
import {
  tourFilterSelector,
  tourSearchSelector,
} from '@src/store/ui/selectors';
import { TourFilter } from '@src/store/ui/types';

type TourSearch = {
  search: string;
  setSearch(q: string): void;
  filter: TourFilter;
  setFilter(filter: TourFilter): void;
};

const useTourSearch = (): TourSearch => {
  const dispatcher = useDispatch();
  const search = useSelector(tourSearchSelector);
  const filter = useSelector(tourFilterSelector);

  const setSearch = React.useCallback(
    (q: string) => {
      dispatcher(setTourSearchAction(q));
    },
    [dispatcher]
  );
  const setFilter = React.useCallback(
    (f: TourFilter) => {
      dispatcher(setTourFilterAction(f));
    },
    [dispatcher]
  );

  return React.useMemo(
    () => ({
      search,
      setSearch,
      filter,
      setFilter,
    }),
    [filter, search, setFilter, setSearch]
  );
};

export default useTourSearch;
